var _stop, _stop2, _stop3, _stop4, _image, _stop5, _stop6, _stop7, _stop8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleAnalyticsIcon = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2500,
    height: 2498,
    viewBox: "0 0 152.1 152"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "google-analytics-icon_svg__a",
    x2: 152.1,
    y1: 77.32,
    y2: 77.32,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)",
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M139.8 0h-27.7c-6.7 0-12.2 5.5-12.2 12.2V48H59.8C53.3 48 48 53.3 48 59.9V100H11.9C5.3 100 0 105.3 0 111.9v28c0 6.6 5.3 11.9 11.9 12.1h128c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0",
    style: {
      fill: "url(#" + _uid + "google-analytics-icon_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "google-analytics-icon_svg__b",
    x2: 152.1,
    y1: 77.32,
    y2: 77.32,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)",
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M139.8 0h-27.7c-6.7 0-12.2 5.5-12.2 12.2V48H59.8C53.3 48 48 53.3 48 59.9V100H11.9C5.3 100 0 105.3 0 111.9v28c0 6.6 5.3 11.9 11.9 12.1h128c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0",
    style: {
      fill: "url(#" + _uid + "google-analytics-icon_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: _uid + "google-analytics-icon_svg__c",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "google-analytics-icon_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#" + _uid + "google-analytics-icon_svg__c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#" + _uid + "google-analytics-icon_svg__d)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V152h39.7c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0",
    style: {
      fill: "#f57c00"
    }
  }), _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "D219C75C03CDCBF6.png",
    width: 125,
    height: 129,
    opacity: 0.2,
    overflow: "visible",
    transform: "translate(-9 39)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48 60v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h88V48H60c-6.6 0-12 5.4-12 12",
    style: {
      fill: "#ffc107"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: _uid + "google-analytics-icon_svg__e",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "google-analytics-icon_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#" + _uid + "google-analytics-icon_svg__e",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "google-analytics-icon_svg__g",
    x1: 74.25,
    x2: 148.36,
    y1: 79.07,
    y2: 4.96,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)",
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c",
    stopOpacity: 0.2
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf360c",
    stopOpacity: 0.02
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100 48v104h39.7c6.7 0 12.2-5.5 12.2-12.2V100z",
    style: {
      clipPath: "url(#" + _uid + "google-analytics-icon_svg__f)",
      fill: "url(#" + _uid + "google-analytics-icon_svg__g)"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: _uid + "google-analytics-icon_svg__h",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "google-analytics-icon_svg__i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#" + _uid + "google-analytics-icon_svg__h",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60 49h40v-1H60c-6.6 0-12 5.4-12 12v1c0-6.6 5.4-12 12-12",
    style: {
      opacity: 0.2,
      clipPath: "url(#" + _uid + "google-analytics-icon_svg__i)",
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: _uid + "google-analytics-icon_svg__j",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "google-analytics-icon_svg__k"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#" + _uid + "google-analytics-icon_svg__j",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 101h36v-1H12c-6.6 0-12 5.4-12 12v1c0-6.6 5.4-12 12-12",
    style: {
      opacity: 0.2,
      fill: "#fff",
      clipPath: "url(#" + _uid + "google-analytics-icon_svg__k)"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: _uid + "google-analytics-icon_svg__l",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "google-analytics-icon_svg__m"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#" + _uid + "google-analytics-icon_svg__l",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2v1c0-6.7 5.5-12.2 12.2-12.2h27.5c6.7 0 12.2 5.5 12.2 12.2v-1C152 5.5 146.5 0 139.8 0",
    style: {
      opacity: 0.2,
      fill: "#fff",
      clipPath: "url(#" + _uid + "google-analytics-icon_svg__m)"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: _uid + "google-analytics-icon_svg__n",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "google-analytics-icon_svg__o"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#" + _uid + "google-analytics-icon_svg__n",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.8 151H12c-6.6 0-12-5.4-12-12v1c0 6.6 5.4 12 12 12h127.7c6.7 0 12.2-5.5 12.2-12.2v-1c.1 6.7-5.4 12.2-12.1 12.2",
    style: {
      opacity: 0.2,
      clipPath: "url(#" + _uid + "google-analytics-icon_svg__o)",
      fill: "#bf360c"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: _uid + "google-analytics-icon_svg__p",
    x1: 50.969,
    x2: 149.295,
    y1: 102.289,
    y2: 3.963,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)",
    gradientUnits: "userSpaceOnUse"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0",
    style: {
      fill: "url(#" + _uid + "google-analytics-icon_svg__p)"
    }
  }));
};
export { SvgGoogleAnalyticsIcon as ReactComponent };
export default __webpack_public_path__ + "20838bd2b665f826e318da742703a510.svg";